import axios from 'axios';
import get from 'lodash/get';
import Cookies from 'universal-cookie';

const baseURL = `${process.env.NEXT_PUBLIC_WAVE_HOSTNAME}/api/offers`;
const cookies = new Cookies();
const token = cookies.get('token');

export async function checkCoupon(couponCode, authToken) {
  try {
    const response = await axios.get(`${baseURL}/checkCouponIsValid/${couponCode}`, {
      headers: {
        appId: process.env.appId,
        authorization: `Bearer ${authToken || token}`,
      },
    });
    const res = get(response, 'data.payload.coupons');
    return res;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
}

export default { checkCoupon };
